// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"206":"3d5205ea","587":"63c5b844","848":"b0911cfe"}[chunkId] + ".css";
};